/** @jsxImportSource @emotion/react */
import { useEffect, useState, useContext, memo } from "react";
import AppBar from "../../components/AppBar";
import Grid from "@mui/material/Grid";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import CloseIcon from "@mui/icons-material/Close";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

import { UserContext } from "../../context/UserContext";
import { useGetNavItems } from "../Home/appbarNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useGetRewardsScreenStyles } from "./index.styles";
import { useGetHomeScreenStyles } from "../Home/index.styles";
// PDF viewer handled by @react-pdf-viewer/core
import StoreCard from "../Home/components/StoreCard";
import OfferCard from "../../components/OfferCard";
import { useFavourites } from "../../hooks/services/useFavourites";
import { Radio } from "antd";
import { useMail } from "../../hooks/services/useMail";

import Snackbar from "../../components/Snackbar";

// Timer handled via useEffect countdown
import { SearchOutlined } from "@mui/icons-material";
import useGetColors from "../../utils/colors";
import { useLocation, useNavigate } from "react-router-dom";
import Footer1 from "../../components/Footer/Footer";
import axios from "axios";
import { baseUrl } from "../../connections";
import { Container } from "react-bootstrap";
import VideoPlayer from "../../components/VideoPlayer";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const arr = new Array(14).fill("").map((item, idx) => idx);

const PdfViewer = memo(({ fileUrl }) => (
  <div
    style={{
      width: "100%",
      height: "100%",
      minHeight: "300px",
      borderRadius: "0",
      overflow: "auto",
      background: "#fff",
    }}
  >
    <Viewer fileUrl={fileUrl} />
  </div>
));

const Favourites = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const classes = useGetRewardsScreenStyles();
  const homeClasses = useGetHomeScreenStyles();
  const { userDetails } = useContext(UserContext);
  const { offerCardMultiColors: colors } = useGetColors();
  const [redeemedOfferIndexes, setRedeemedOfferIndexes] = useState([]);
  const {
    brandData = [],
    mailData = [],
    setFavPayload,
    setUpdateBrandFav,
    setUpdateMailFav,
    error,
  } = useFavourites();
  const options = ["Brands", "Mails"];
  const [option, setOption] = useState(options[0]);
  const [searchValue, setSearchValue] = useState("");

  const {
    mailList,
    isRedeem,
    redeemMessage,
    redeemError,
    setMailPayload,
    mailHTML,
    setMailURL,
    setUpdateMailRedeem,
  } = useMail();
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerContentRoute, setDrawerContentRoute] = useState("search");
  const [offerCard, setOfferCard] = useState({});

  const [mailSubscribeUpdate, setmailSubscribeUpdate] = useState(false);

  useEffect(() => {
    if (userDetails)
      setFavPayload(
        `pagenum=0&limit=100&user_uuid=${userDetails?.uuid}&country_uuid=${userDetails?.address?.country}&state_uuid=${userDetails?.address?.state}&city_uuid=${userDetails?.address?.city}&county_uuid=${userDetails?.address?.county}`,
      );
  }, [userDetails, mailSubscribeUpdate]);

  const onOptionChange = ({ target: { value } }) => {
    setOption(value);
    setSearchValue("");
  };

  const onFavouriteToggle = (e, uuid, type) => {
    e.preventDefault();
    type === "brand"
      ? setUpdateBrandFav({
          user_uuid: userDetails?.uuid,
          brand_uuid: uuid,
        })
      : setUpdateMailFav({
          user_uuid: userDetails?.uuid,
          mail_uuid: uuid,
        });
  };

  // --- Timer for paid mails (15-second countdown) ---
  const [timerSeconds, setTimerSeconds] = useState(18);

  useEffect(() => {
    if (
      showDrawer &&
      drawerContentRoute === "offerCard" &&
      offerCard?.type === "paid" &&
      offerCard?.is_seen === "false"
    ) {
      setTimerSeconds(18);
      const timer = setInterval(() => {
        setTimerSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            // Timer finished — now actually redeem
            setUpdateMailRedeem({
              user_uuid: userDetails?.uuid,
              mail_uuid: offerCard?.uuid,
            });
            // Mark as redeemed locally so timer won't show again
            setOfferCard((prevCard) => ({ ...prevCard, is_seen: "true" }));
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    } else if (
      showDrawer &&
      drawerContentRoute === "offerCard" &&
      offerCard?.type === "paid" &&
      offerCard?.is_seen === "true"
    ) {
      // Already redeemed — ensure timer shows 0
      setTimerSeconds(0);
    }
  }, [showDrawer, drawerContentRoute, offerCard?.uuid]);

  // Helper: determine if the content is a plain image
  const isPlainImage =
    offerCard &&
    !offerCard?.video_url &&
    offerCard?.mime_type !== "text/html" &&
    offerCard?.mime_type !== "application/pdf" &&
    offerCard?.image_url !== null;

  const DrawerOfferCardContent = () => {
    const isPaid = offerCard?.type === "paid";
    const isUnseen = offerCard?.is_seen === "false";
    const isSeen = offerCard?.is_seen === "true";
    const hasVideo = !!offerCard?.video_url;
    const isHTML = offerCard?.mime_type === "text/html";
    const isPDF = offerCard?.mime_type === "application/pdf";
    const hasNonImageMedia = hasVideo || isHTML || isPDF;
    const isRedeeming = isPaid && isUnseen && timerSeconds > 0;

    const handleCloseModal = () => {
      if (isRedeeming) return; // Block closing while redeeming
      setShowDrawer(false);
    };

    // --- Media rendering ---
    const renderMedia = () => {
      if (hasVideo) {
        return (
          <div
            style={{
              minidth: "580px",
              minHeight: "340px",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            }}
          >
            <VideoPlayer
              url={offerCard?.video_url}
              width="100%"
              height="360px"
            />
          </div>
        );
      }
      if (isHTML) {
        return (
          <div
            style={{
              width: "100%",
              maxWidth: "100%",
              margin: "0 auto",
              padding: "16px",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
            }}
            dangerouslySetInnerHTML={{ __html: mailHTML }}
          />
        );
      }
      if (isPDF) {
        return <PdfViewer fileUrl={offerCard?.image_url} />;
      }
      // Plain image
      if (offerCard?.image_url) {
        return (
          <img src={offerCard?.image_url} alt={offerCard?.subject || "Offer"} />
        );
      }
      return (
        <span style={{ color: "#999", padding: "40px" }}>
          No File Available
        </span>
      );
    };

    // --- Content section ---
    const store = offerCard?.brand?.[0];
    const renderContent = () => (
      <>
        {/* Store row: image left, name + badges right */}
        <div css={homeClasses.offerModalStoreRow}>
          {store?.logo_url && (
            <img
              css={homeClasses.offerModalStoreLogo}
              src={store?.logo_url}
              alt={store?.name || "Store"}
            />
          )}
          <div css={homeClasses.offerModalStoreInfo}>
            {store?.name && (
              <div css={homeClasses.offerModalStoreName}>{store.name}</div>
            )}
            {/* Subject — shown right under store name */}
            <h5 css={homeClasses.offerModalSubject}>
              {offerCard?.subject || ""}
            </h5>
            <div css={homeClasses.offerModalStoreBadges}>
              <div
                css={[
                  homeClasses.offerModalType,
                  isPaid
                    ? homeClasses.offerModalTypePaid
                    : homeClasses.offerModalTypeRegular,
                ]}
              >
                {isPaid ? "💰 Paid Mail" : "📬 Regular Mail"}
              </div>

              {/* Amount badge for paid */}
              {isPaid && offerCard?.amount > 0 && (
                <div css={homeClasses.offerModalAmount}>
                  <StarRoundedIcon style={{ fontSize: "16px" }} />
                  {offerCard?.amount} Points
                </div>
              )}

              {/* Already redeemed badge */}
              {isPaid && isSeen && (
                <div css={homeClasses.offerModalRedeemBadge}>
                  <CheckCircleIcon style={{ fontSize: "16px" }} />
                  Redeemed
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Message */}
        <div
          css={homeClasses.offerModalMessage}
          dangerouslySetInnerHTML={{ __html: offerCard?.message || "" }}
        />
      </>
    );

    return (
      <div
        css={homeClasses.offerModalOverlay}
        onClick={(e) => {
          if (!isRedeeming) handleCloseModal();
        }}
      >
        {/* Back button — outside modal, top left */}
        {!isRedeeming && (
          <button
            css={homeClasses.offerModalBack}
            onClick={(e) => {
              e.stopPropagation();
              handleCloseModal();
            }}
          >
            <ArrowBackIosIcon /> Back
          </button>
        )}

        {/* Close button — outside modal, top right */}
        {!isRedeeming && (
          <button
            css={homeClasses.offerModalClose}
            onClick={(e) => {
              e.stopPropagation();
              handleCloseModal();
            }}
          >
            <CloseIcon />
          </button>
        )}

        {/* Floating redeem bar — outside modal, bottom center */}
        {isPaid && isUnseen && (
          <div
            css={homeClasses.offerModalRedeemBar}
            onClick={(e) => e.stopPropagation()}
          >
            <AccessTimeIcon css={homeClasses.offerModalTimerIcon} />
            {timerSeconds > 0 ? (
              <>
                <span css={homeClasses.offerModalTimerText}>Redeeming in</span>
                <span css={homeClasses.offerModalTimerCount}>
                  {timerSeconds}s
                </span>
              </>
            ) : (
              <>
                <CheckCircleIcon
                  style={{ color: "#2e7d32", fontSize: "22px" }}
                />
                <span
                  css={homeClasses.offerModalTimerText}
                  style={{ color: "#2e7d32" }}
                >
                  Redeemed!
                </span>
              </>
            )}
          </div>
        )}

        <div
          css={[
            homeClasses.offerModalCard,
            isPDF && homeClasses.offerModalCardPdf,
          ]}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Layout: horizontal for plain images & PDFs, vertical for video/html */}
          {(isPlainImage && !hasNonImageMedia) || isPDF ? (
            <div css={homeClasses.offerModalHorizontal}>
              <div css={homeClasses.offerModalMediaLeft}>{renderMedia()}</div>
              <div css={homeClasses.offerModalContentRight}>
                {renderContent()}
              </div>
            </div>
          ) : (
            <div css={homeClasses.offerModalVertical}>
              <div css={homeClasses.offerModalMediaTop}>{renderMedia()}</div>
              <div css={homeClasses.offerModalContentBelow}>
                {renderContent()}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    // if(redeemError === false && offerCard?.type === "paid") {
    //   setShowDrawer(true)
    // }
    if (offerCard?.type === "paid") {
      setShowDrawer(true);
    }
  }, [redeemError, isRedeem]);

  const handleNavLinksClick = (route, item) => {
    const isRedeemed = item?.is_seen === "true";
    if (item?.mime_type === "text/html") {
      const url = item?.image_url?.split("/");
      setMailURL({ html_url: url.slice(-1)[0] });
    }
    setOfferCard(item);
    // setShowDrawer(true);
    // setDrawerContentRoute(route);
    setDrawerContentRoute(route);
    if (route === "offerCard") {
      setShowDrawer(true);
    }

    if (item?.type === "paid" && !isRedeemed) {
      // Paid mails: redeem is deferred until timer finishes (18s)
      // setUpdateMailRedeem called from timer useEffect when countdown reaches 0
    }

    //****Location Check ******/
  };

  const onSearchInput = (e) => {
    e.preventDefault();
    setSearchValue(e.target.value);
    if (e.target.value.length > 2) {
      setFavPayload(
        `user_uuid=${userDetails?.uuid}&country_uuid=${userDetails?.address?.country}&state_uuid=${userDetails?.address?.state}&city_uuid=${userDetails?.address?.city}&county_uuid=${userDetails?.address?.county}&search=${e.target.value}`,
      );
    }
    if (e.target.value === "")
      setFavPayload(
        `pagenum=0&limit=100&user_uuid=${userDetails?.uuid}&country_uuid=${userDetails?.address?.country}&state_uuid=${userDetails?.address?.state}&city_uuid=${userDetails?.address?.city}&county_uuid=${userDetails?.address?.county}`,
      );
  };

  const [subscribeshow, setSubscribeShow] = useState(false);
  const unSubscribeMail = (dataSub) => {
    const payload = {
      mail_uuid: dataSub?.uuid,
      user_uuid: userDetails?.uuid,
    };
    axios
      .put(`${baseUrl}/mail/unsubscribe`, payload, {
        headers: {
          "x-auth-token": userDetails?.token,
        },
      })
      .then((res) => {
        setSubscribeShow(false);
        setmailSubscribeUpdate(mailSubscribeUpdate ? false : true);
        if (userDetails)
          setFavPayload(
            `pagenum=0&limit=100&user_uuid=${userDetails?.uuid}&country_uuid=${userDetails?.address?.country}&state_uuid=${userDetails?.address?.state}&city_uuid=${userDetails?.address?.city}&county_uuid=${userDetails?.address?.county}`,
          );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div css={classes.pageContainer}>
      <AppBar navItems={useGetNavItems({}).navItems} pageTitle="My Favourites" />
      <Container>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={12} md={4}>
            <div css={classes.subWraper}>
              <div css={classes.radioGroup}>
                <Radio.Group
                  options={options}
                  onChange={onOptionChange}
                  value={option}
                  optionType="button"
                  buttonStyle="solid"
                />
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            style={{ marginRight: "20px", marginLeft: "20px" }}
          >
            <div css={classes.searchWrapper}>
              <SearchOutlined sx={classes.searchIcon} />
              <input
                css={classes.search}
                placeholder={`Search ${option}`}
                onChange={onSearchInput}
              />
            </div>
          </Grid>
        </Grid>

        <div css={classes.brandCardsInSearchWrapper}>
          {option === options[0] ? (
            <>
              {brandData && brandData.length > 0 ? (
                brandData.map((item) => (
                  <StoreCard
                    key={item?.uuid}
                    item={item}
                    selBrand={[]}
                    classes={homeClasses}
                    onFavouriteToggle={(e, id) =>
                      onFavouriteToggle(e, id, "brand")
                    }
                    onBrandSelect={() =>
                      navigate("/home", {
                        state: {
                          data: {
                            selCountry: location?.state?.selCountry,
                            selState: location?.state?.selState,
                            selCity: location?.state?.selCity,
                            selCounty: location?.state?.selCounty,
                            selCategory: item?.category_uuid?.[0],
                          },
                          id: item?.uuid,
                        },
                      })
                    }
                  />
                ))
              ) : (
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    padding: "48px 20px",
                    color: "#777",
                    fontSize: "1rem",
                  }}
                >
                  <span
                    style={{
                      fontSize: "2.5rem",
                      display: "block",
                      marginBottom: "12px",
                    }}
                  >
                    🏪
                  </span>
                  No favourite stores yet
                </div>
              )}
            </>
          ) : (
            <>
              {mailData && mailData.length > 0 ? (
                mailData.map((item, i) => {
                  let j = i % 4;
                  return (
                    <div css={classes.categoryWrapper} key={item?.uuid || i}>
                      <OfferCard
                        key={item?.uuid || i}
                        isRedeemed={item?.is_seen === "true" ? true : false}
                        item={item}
                        UnsubscribeMailClick={() => unSubscribeMail(item)}
                        show={subscribeshow}
                        setShow={(e1) => setSubscribeShow(e1)}
                        isFavourite={true}
                        onFavouriteMailToggle={(e) =>
                          onFavouriteToggle(e, item?.uuid)
                        }
                        onClick={() => {
                          handleNavLinksClick("offerCard", item);
                        }}
                      />
                      <span css={classes.categoryText}>{item?.name}</span>
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    padding: "48px 20px",
                    color: "#777",
                    fontSize: "1rem",
                  }}
                >
                  <span
                    style={{
                      fontSize: "2.5rem",
                      display: "block",
                      marginBottom: "12px",
                    }}
                  >
                    📬
                  </span>
                  No favourite mails yet
                </div>
              )}
            </>
          )}
        </div>
      </Container>
      {/* <AppFooter /> */}
      <Footer1 />
      {showDrawer && drawerContentRoute === "offerCard" && (
        DrawerOfferCardContent()
      )}
      {isRedeem && (
        <Snackbar
          message={redeemMessage}
          isOpen={isRedeem}
          severity={redeemError ? "error" : "success"}
        />
      )}
    </div>
  );
};

export default Favourites;
